import {
    UserRole,
    getPrimaryRole,
    isOrganizationRole,
    isUserAdmin,
} from 'src/domain/user';
import { useSignedInUser } from './useSignedInUser';
export const useHomePath = () => {
    const user = useSignedInUser();
    const role = getPrimaryRole(user);
    if (isUserAdmin(user)) {
        return '/app/admin';
    }
    if (role === UserRole.nextOfKin) {
        return '/app/nextofkin-image-list';
    }
    if (role === UserRole.creator || isOrganizationRole(role)) {
        return '/app/home';
    }
    return '/';
};
